<template>
    <div>
        <div id="main" ></div>
    </div>

</template>

<script>
    export default {
        name: 'BarCharts',
        data () {
            return {
              myChart: null,
              optionSeries: [],
              option: {
                title: {
                  text: '平均维修次数分析'
                  // subtext: '纯属虚构'
                },
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data: ['平均维修次数分析']
                },
                toolbox: {
                  show: true,
                  feature: {
                    // dataView: {show: true, readOnly: false},
                    // magicType: {show: true, type: ['pie', 'line', 'bar']},
                    // restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                calculable: true,
                grid: { y2: 150 // 增加柱形图纵向的高度
                },
                xAxis: [
                  {
                    type: 'category',
                    // data: ['镇地方大师傅1', '点2', '梵蒂3', '4', '镇5', '镇6', '7', '乡第方8', '9', '乡0', '11', '12', '13', '14', '15', '16', '17', '乡8'],
                  data: [],
                  axisLabel: {
                    showMaxLabel: true,

                      formatter: function (value) { // 让x轴字体垂直显示;如果柱形图x轴的信息太长会出现显示不全或者信息重叠在一起
                        return value.split('').join('\n')
                      },
                    textStyle: {
                      fontSize: 18
                    }
                    // interval: -1, // 横轴信息全部显示
                     // rotate: 5 // -15度角倾斜显示
                  }
                  }
                ],
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: [
                  {
                    name: '平均抽厕次数分析',
                    type: 'bar',
                    data: [],
                     // data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3, 76.7, 135.6, 162.2, 32.6, 20.0, 14],
                    markPoint: {
                      data: [
                        {type: 'max', name: '最大值'},
                        {type: 'min', name: '最小值'}
                      ]
                    },
                    markLine: {
                      data: [
                        {type: 'average', name: '平均值'}
                      ]
                    }
                  }
                ]
              }
            }
        },
        mounted () {
           // this.init()
        },
        methods: {
            init () {
              // 判断图标是否存在
              let _this = this
              document.getElementById('main').style.height = '650px'
              document.getElementById('main').style.width = '95%'
              // 基于准备好的dom，初始化echarts实例
              _this.myChart = this.$echarts.init(document.getElementById('main'),'light')
              _this.myChart.setOption(this.option)
              _this.myChart.on('click', function (data) {
                _this.$emit('changeBarDate', data.name)
              }) // 增加点击事件; data是系列series.data数组对应的对象值
            },
            showInit (data) {
              // alert(JSON.stringify(data))
              this.optionSeries = null
              this.option.series[0].data = []
              this.option.xAxis[0].data = []
               for (var i = 0; i < data.length; i++) {
                // alert(data[i].num)
                 this.option.series[0].data.push(data[i].pumpNum)
                 this.option.xAxis[0].data.push(data[i].name)
               }
              this.init()
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/system/Maintenance/BarCharts.vue